import { render } from "./ProjectTemplate.vue?vue&type=template&id=056dab16&scoped=true&ts=true"
import script from "./ProjectTemplate.vue?vue&type=script&lang=ts"
export * from "./ProjectTemplate.vue?vue&type=script&lang=ts"

import "./ProjectTemplate.vue?vue&type=style&index=0&id=056dab16&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-056dab16"]])

export default __exports__